


import {UserType} from './UserType'; 
export class JoinSessionVM {
    
    userType?: UserType;
    
    sessionId?: string;
    
    pin?: string;
    
    sourceIP?: string;
    
}
